// src/pages/DirectPage/styles.js
import { COLORS, LAYOUT, TYPOGRAPHY } from '../../constants';

export const directPageStyles = {
  // Page Container
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: LAYOUT.background,
    padding: '20px',
  },

  // Main container
  container: {
    maxWidth: '1000px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
  },

  // Chat header
  chatHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '24px',
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #a00e1f 100%)`,
    color: '#ffffff',
  },

  backButton: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: 'none',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
    },
  },

  avatarWrapper: {
    flexShrink: 0,
  },

  sellerAvatar: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '3px solid rgba(255, 255, 255, 0.3)',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },

  avatarPlaceholder: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: '3px solid rgba(255, 255, 255, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
  },

  sellerInfo: {
    flex: 1,
  },

  sellerName: {
    fontSize: '20px',
    fontWeight: '700',
    margin: '0 0 4px 0',
    letterSpacing: '-0.3px',
  },

  sellerStatus: {
    fontSize: '13px',
    margin: 0,
    opacity: 0.9,
  },

  // Chat Window
  chatWindow: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 200px)',
    maxHeight: '700px',
  },

  // Messages container
  messagesContainer: {
    flex: 1,
    padding: '20px 24px',
    overflowY: 'auto',
    backgroundColor: '#fafbfc',
    display: 'flex',
    flexDirection: 'column',
  },

  // Empty state
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    textAlign: 'center',
  },

  emptyIcon: {
    color: COLORS.primary,
    opacity: 0.3,
    marginBottom: '20px',
  },

  emptyTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: COLORS.secondary,
    margin: '0 0 8px 0',
  },

  emptyMessage: {
    fontSize: '15px',
    color: '#666',
    margin: 0,
  },

  // Message bubble container
  messageContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
    marginBottom: '2px',
    paddingLeft: '8px',
    paddingRight: '8px',
  },

  messageContainerSent: {
    justifyContent: 'flex-end',
  },

  messageContainerReceived: {
    justifyContent: 'flex-start',
  },

  // Avatar in messages
  messageAvatarContainer: {
    width: '32px',
    height: '32px',
    flexShrink: 0,
  },

  messageAvatar: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid #ffffff',
    backgroundColor: '#f5f5f5',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.15)',
  },

  messageAvatarPlaceholder: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: '#fef5f6',
    border: '2px solid #ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: COLORS.primary,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.15)',
  },

  // Message bubble wrapper
  messageBubbleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    maxWidth: '60%',
    minWidth: '60px',
  },

  // Message bubble
  messageBubbleBase: {
    display: 'inline-block',
    padding: '10px 14px',
    borderRadius: '18px',
    fontSize: '15px',
    lineHeight: '1.4',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },

  messageBubbleSent: {
    backgroundColor: COLORS.primary,
    color: '#ffffff',
    borderBottomRightRadius: '4px',
    boxShadow: '0 1px 2px rgba(206, 17, 38, 0.2)',
  },

  messageBubbleReceived: {
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    borderBottomLeftRadius: '4px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e8e8e8',
  },

  timestampSent: {
    fontSize: '11px',
    color: '#999',
    textAlign: 'right',
    paddingRight: '4px',
  },

  timestampReceived: {
    fontSize: '11px',
    color: '#999',
    textAlign: 'left',
    paddingLeft: '4px',
  },

  // Input Container
  inputContainer: {
    borderTop: '1px solid #e0e0e0',
    backgroundColor: '#ffffff',
    padding: '16px 24px 20px 24px',
  },

  // Emoji Bar
  emojiBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '12px',
    flexWrap: 'wrap',
  },

  emojiLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '12px',
    color: '#888',
    fontWeight: '500',
  },

  emojiButton: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    border: '1px solid #e8e8e8',
    backgroundColor: '#ffffff',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      backgroundColor: '#fef5f6',
      borderColor: COLORS.primary,
      transform: 'scale(1.05)',
    },
  },

  // Message input form
  inputForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  inputRow: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },

  messageInput: {
    flex: 1,
    padding: '12px 16px',
    borderRadius: '24px',
    border: '1.5px solid #e0e0e0',
    fontSize: '15px',
    outline: 'none',
    transition: 'all 0.2s ease',
    backgroundColor: '#fafafa',
    fontFamily: TYPOGRAPHY.fontFamily,
    lineHeight: '1.4',
  },

  messageInputFocused: {
    borderColor: COLORS.primary,
    backgroundColor: '#ffffff',
    boxShadow: '0 0 0 3px rgba(206, 17, 38, 0.1)',
  },

  sendButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '12px 20px',
    borderRadius: '24px',
    border: 'none',
    backgroundColor: '#e8e8e8',
    color: '#999',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'not-allowed',
    transition: 'all 0.2s ease',
    fontFamily: TYPOGRAPHY.fontFamily,
  },

  sendButtonActive: {
    backgroundColor: COLORS.primary,
    color: '#ffffff',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(206, 17, 38, 0.25)',
    ':hover': {
      backgroundColor: '#a00e1f',
      boxShadow: '0 4px 12px rgba(206, 17, 38, 0.3)',
    },
  },
};

// Inject keyframe animation for spinner
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `;
  document.head.appendChild(style);
}